"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChartTooltip = void 0;
require("core-js/modules/es.number.to-fixed.js");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _constants = require("../../utils/constants");
var _useReactMoment = require("../../hooks/useReactMoment");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ChartTooltip = _ref => {
  var _data$find, _point$data, _point$data2;
  let {
    PointTooltipProps,
    dateType,
    data
  } = _ref;
  const {
    reactMoment
  } = (0, _useReactMoment.useReactMoment)();
  const {
    point = {}
  } = PointTooltipProps;
  const title = ((_data$find = data.find(item => item.id === point.serieId)) === null || _data$find === void 0 ? void 0 : _data$find.title) || '';
  return /*#__PURE__*/_react.default.createElement(_material.Card, {
    sx: {
      px: 2,
      py: 1,
      boxShadow: _constants.styles.boxShadow.primary,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'initial',
      '&:before': {
        content: '""',
        position: 'absolute',
        bottom: '-11px',
        width: '12px',
        height: '12px',
        backgroundColor: 'inherit',
        transform: 'rotate(45deg) translate(-70%, 0)',
        left: '50%'
      }
    },
    className: "line-chart-tooltip-value"
  }, dateType !== _constants.constDateType.year && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "caption",
    sx: {
      color: _constants.colors['main-color-cl-13']
    }
  }, point !== null && point !== void 0 && (_point$data = point.data) !== null && _point$data !== void 0 && _point$data.x ? reactMoment(point === null || point === void 0 || (_point$data2 = point.data) === null || _point$data2 === void 0 ? void 0 : _point$data2.x).format('HH:mm MMM DD') : '-'), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "body2",
    component: "div",
    sx: {
      color: _constants.colors['main-color-cl-01'],
      fontWeight: 600
    }
  }, title), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "body2",
    sx: {
      color: _constants.colors['main-color-cl-01'],
      fontWeight: 600
    }
  }, point.data ? "".concat(point.data.y.toFixed(0), " \xB0C") : '-'));
};
exports.ChartTooltip = ChartTooltip;
ChartTooltip.propTypes = {
  PointTooltipProps: _propTypes.default.shape({
    point: _propTypes.default.shape({
      id: _propTypes.default.string.isRequired,
      index: _propTypes.default.number.isRequired,
      serieId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
      serieColor: _propTypes.default.string.isRequired,
      x: _propTypes.default.number.isRequired,
      y: _propTypes.default.number.isRequired,
      color: _propTypes.default.string.isRequired,
      borderColor: _propTypes.default.string.isRequired,
      data: _propTypes.default.shape({
        x: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.instanceOf(Date)]),
        xFormatted: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
        y: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.instanceOf(Date)]),
        yFormatted: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
        yStacked: _propTypes.default.number
      }).isRequired
    }).isRequired
  }),
  // PointTooltipProps
  dateType: _propTypes.default.oneOf(Object.values(_constants.constDateType)),
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string,
    title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element])
  }))
};